import React from 'react'

import { ReactComponent as ArrowDown } from 'shared/assets/icons/arrowDown.svg'

export default function Accordion({
  items = [],
  active = '',
  title,
  isOpen = false,
  toggle,
  selectOption
}) {

  return (
    <div className="px-[16px] py-[10px] cursor-pointer border-solid border-[#C7CCD9] border-b-[1px]" onClick={toggle}>
      <div className="flex justify-between items-center]">
        <span className="leading-[21px] md:text-[18px] font-semibold">{title}</span>
        <ArrowDown className={`w-[20px] h-[20px] ${isOpen ? '' : '-rotate-90'}`} />
      </div>
      {isOpen && (
        <ul>
          {items.map((i, index) => (
            <li
              key={index}
              onClick={() => selectOption(i, index)}
              className={`text-[14px] leading-[21px] md:text-[16px] font-medium mt-[10px] md:mt-[13px]
                ${active === i
                  ? 'text-black before:content-["•"] before:inline-block before:w-[15px] before:text-[20px] before:leading-[17px]'
                  : 'text-[#5F6787] pl-[15px]'}`}
            >{i}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
